import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EmptystateFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4 12.9001H10.6667V11.1001H4V12.9001ZM13.3333 12.9001L19.9999 12.9001L19.9999 11.1001H13.3333V12.9001Z"
      />
    </SvgIcon>
  );
});
